import React from 'react';
import { type RCStarRatingProps, RCStarRating } from '../RCStarRating/RCStarRating';
import { RCAvatar } from '../';

export interface RCShopInfoProps {
  /** The URL for the avatar */
  avatarURL?: string;

  /** The name of the shop */
  name: string;

  /** The shop's location in the world */
  location?: string;

  /** The shop's rating - See [RCStarRating](/?path=/docs/design-system-rcstarrating--default) for details */
  rating?: Omit<RCStarRatingProps, 'largeStars'>;
}

export function RCShopInfo({
  avatarURL = undefined,
  name = undefined,
  location = undefined,
  rating = undefined,
}: RCShopInfoProps) {
  return (
    <div className="rc-shop-info">
      {avatarURL && (
        <div className="rc-shop-info__avatar">
          <RCAvatar
            userName={name}
            thumbnailURL={avatarURL}
          />
        </div>
      )}
      <div className="rc-shop-info__content">
        <div className="rc-shop-info__name">
          {name}
        </div>
        {location && (
          <div className="rc-shop-info__location">
            {location}
          </div>
        )}
        {(rating && rating?.rating > 0) && (
          <div className="rc-shop-info__rating">
            <RCStarRating {...rating} />
          </div>
        )}
      </div>
    </div>
  );
}
